// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsTabContainer, SettingsTabContent} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import AuthorizedAppsTab from '@app/features/user/components/modals/tabs/AuthorizedAppsTab';
import BlockedUsersTab from '@app/features/user/components/modals/tabs/BlockedUsersTab';
import DevicesTab from '@app/features/user/components/modals/tabs/DevicesTab';
import {PrivacySafetyInlineContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/PrivacySafetyTabInline';
import type {AccountNestedSettingsTabType} from '@app/features/user/components/settings_utils/SettingsNavigationGroups';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface AccountNestedPageProps {
	page: AccountNestedSettingsTabType;
}

export const AccountNestedPage: React.FC<AccountNestedPageProps> = observer(({page}) => {
	if (page === 'devices') {
		return <DevicesTab data-flx="user.account-security-tab.account-nested-page.devices-tab" />;
	}

	return (
		<SettingsTabContainer data-flx="user.account-security-tab.account-nested-page.settings-tab-container">
			<SettingsTabContent data-flx="user.account-security-tab.account-nested-page.settings-tab-content">
				{page === 'privacy_safety' && (
					<PrivacySafetyInlineContent data-flx="user.account-security-tab.account-nested-page.privacy-safety" />
				)}
				{page === 'authorized_apps' && (
					<AuthorizedAppsTab data-flx="user.account-security-tab.account-nested-page.authorized-apps" />
				)}
				{page === 'blocked_users' && (
					<BlockedUsersTab data-flx="user.account-security-tab.account-nested-page.blocked-users" />
				)}
			</SettingsTabContent>
		</SettingsTabContainer>
	);
});
